export const INVESTOR_SLIDES = [
  { id: "title", label: "Cover", badge: undefined },
  { id: "opportunity", label: "Opportunity", badge: "The Opportunity" },
  { id: "solution", label: "Solution", badge: "The Solution" },
  { id: "proof", label: "Proof", badge: "Proof: It Works" },
  { id: "business-model", label: "Business Model", badge: "The Model" },
  { id: "unit-economics", label: "Unit Economics", badge: "Unit Economics" },
  { id: "dual-tier", label: "Dual-Tier Model", badge: "Dual-Tier Model" },
  { id: "market", label: "Market", badge: "Why Now" },
  { id: "bigger-picture", label: "The Bigger Picture", badge: "The Bigger Picture" },
  { id: "why-us", label: "Why Us", badge: "Why Us" },
  { id: "roadmap", label: "Roadmap", badge: "The Road Ahead" },
  { id: "team", label: "Team", badge: "Team" },
  { id: "the-ask", label: "The Ask", badge: "The Ask" },
  { id: "thank-you", label: "Thank You", badge: undefined },
] as const;

export const INTRO_SLIDES = [
  { id: "cover", label: "Cover", badge: undefined },
  { id: "who-we-are", label: "Who We Are", badge: "Who We Are" },
  { id: "our-approach", label: "Our Approach", badge: "Our Approach" },
  { id: "trust-security", label: "Trust & Security", badge: "Trust & Security" },
  { id: "team", label: "Team", badge: "Team" },
  { id: "cta", label: "Next Steps", badge: undefined },
] as const;

export const INVESTOR_V2_SLIDES = [
  { id: "title", label: "Cover", badge: undefined },
  { id: "opportunity", label: "Opportunity", badge: "The Opportunity" },
  { id: "engine", label: "The Engine", badge: "The Engine" },
  { id: "proof", label: "Proof", badge: "Proof: The Engine Works" },
  { id: "product-clients", label: "Product & Clients", badge: "In Production" },
  { id: "harness", label: "Harness Engineering", badge: "The Technical Moat" },
  { id: "business-model", label: "Business Model", badge: "The Model" },
  { id: "unit-economics", label: "Unit Economics", badge: "Unit Economics" },
  { id: "dual-tier", label: "Dual-Tier Model", badge: "Dual-Tier Model" },
  { id: "market", label: "Market", badge: "Why Now" },
  { id: "bigger-picture", label: "The Bigger Picture", badge: "The Bigger Picture" },
  { id: "why-us", label: "Why Us", badge: "Why Us" },
  { id: "competitive", label: "Competitive Landscape", badge: "Competitive Landscape" },
  { id: "roadmap", label: "Roadmap", badge: "The Road Ahead" },
  { id: "valuation", label: "Valuation Benchmarks", badge: "Valuation Context" },
  { id: "team", label: "Team", badge: "Team" },
  { id: "the-ask", label: "The Ask", badge: "The Ask" },
  { id: "thank-you", label: "Thank You", badge: undefined },
] as const;

export const INVESTOR_V3_SLIDES = [
  { id: "cover", label: "Cover", badge: undefined },
  { id: "overview", label: "Overview", badge: "Overview" },
  { id: "problem", label: "The Problem", badge: "The Problem" },
  { id: "what-we-do", label: "What We Do", badge: "What We Do" },
  { id: "products", label: "Products & Clients", badge: "In Production" },
  { id: "partners", label: "Partners", badge: "Our Partners" },
  { id: "how-we-earn", label: "How We Earn", badge: "How We Earn" },
  { id: "verticals", label: "Verticals", badge: "Three Verticals, One Engine" },
  { id: "market", label: "Market", badge: "The Market" },
  { id: "competition", label: "Competition", badge: "Competition" },
  { id: "scale", label: "How It Scales", badge: "How It Scales" },
  { id: "team", label: "Team", badge: "Team" },
  { id: "the-ask", label: "The Ask", badge: "The Ask" },
  { id: "close", label: "Close", badge: undefined },
] as const;

export const LEGAL_SLIDES = [
  { id: "cover", label: "Cover", badge: undefined },
  { id: "about", label: "About COSX", badge: "About COSX" },
  { id: "problem", label: "The Problem", badge: "The Problem" },
  { id: "shift", label: "The Shift", badge: "The Shift" },
  { id: "capabilities", label: "Agent Skills", badge: "Agent Skills" },
  { id: "how-it-works", label: "How It Works", badge: "How It Works" },
  { id: "proven", label: "Proven", badge: "Proven in Production" },
  { id: "practice-areas", label: "Practice Areas", badge: "Every Practice Area" },
  { id: "security", label: "Security", badge: "Security & Governance" },
  { id: "cta", label: "Next Steps", badge: undefined },
] as const;

export type SlideEntry = { readonly id: string; readonly label: string; readonly badge: string | undefined };

export type SlideMode = "normal" | "presentation" | "export";

export const THEME_KEY = "cosx-theme";

export const NDA_STORAGE_KEY = "cosx-nda-signed";
export const LEGACY_AUTH_KEY = "cosx-investor-auth";
